<template>
  <div class="attainment_detail">
    <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>素养考核</b>
      <div class="btn student_btn">
        <el-select
          v-model="userId"
          placeholder="请选择学生"
          size="mini"
          @change="getDetail"
        >
          <el-option
            v-for="item in studentList"
            :key="item.userId"
            :label="item.name"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="btn chapter_btn">
        <el-cascader
          v-model="classChapterId"
          @change="getDetail"
          :options="chapters"
          :props="{
            label: 'title',
            value: 'classChapterId',
            emitPath: false,
          }"
          :show-all-levels="false"
          size="mini"
          placeholder="请选择章节"
        ></el-cascader>
        <!-- <el-select
          v-model="classChapterId"
          placeholder="请选择章节"
          size="mini"
          @change="getDetail"
        >
          <el-option-group
            v-for="group in chapters"
            :key="group.classChapterId"
            :label="group.title"
          >
            <el-option
              v-for="item in group.children"
              :key="item.classChapterId"
              :label="item.title"
              :value="item.classChapterId"
            >
            </el-option>
          </el-option-group>
        </el-select> -->
      </div>
      <!-- <div class="btn export_btn">
        导出数据 <i class="el-icon-arrow-right"></i>
      </div> -->
    </div>
    <div class="main">
      <div class="box" v-for="(item, idx) in list" :key="idx">
        <p class="box_title">{{ item.title }}</p>
        <div class="content">
          <div class="one_row" v-for="(row, idx) in item.items" :key="idx">
            <span>{{ idx + 1 }}.</span>
            <span style="margin-right: 20px">{{ row.name }}</span>
            <span class="score">{{ scoreDetail[row.score] }}</span>
          </div>
        </div>
      </div>
      <div class="box" v-for="(item, idx) in scoreDetail.otherList" :key="idx">
        <p class="box_title">课堂素养考核{{ idx + 1 }}</p>
        <div class="content">
          <div class="one_row">
            <span style="margin-right: 20px">{{ item.label }}</span>
            <span class="score">{{ item.score }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chapterList } from "@/api/chapter";
import { appraiseDetail } from "@/api/chapter";
import { handleTree } from "@/utils";

export default {
  data() {
    return {
      userId: Number(this.$route.query.userId),
      chapters: [],
      classChapterId: Number(this.$route.query.classChapterId),
      list: [
        {
          title: "社会责任",
          items: [
            {
              name: "诚信友善",
              score: "cxys",
            },
            {
              name: "合作担当",
              score: "hzdd",
            },
            {
              name: "法制信仰",
              score: "fzxy",
            },
            {
              name: "生态意识",
              score: "stcs",
            },
          ],
        },
        {
          title: "国家认同",
          items: [
            {
              name: "国家意识",
              score: "gjys",
            },
            {
              name: "政治认同",
              score: "zzrt",
            },
            {
              name: "文化自信",
              score: "whzx",
            },
          ],
        },
        {
          title: "国际理解",
          items: [
            {
              name: "全球视野",
              score: "qqsy",
            },
            {
              name: "尊重差异",
              score: "zzcy",
            },
          ],
        },
        {
          title: "人文底蕴",
          items: [
            {
              name: "人文积淀",
              score: "rwjd",
            },
            {
              name: "人文情怀",
              score: "rwqh",
            },
          ],
        },
        {
          title: "科学精神",
          items: [
            {
              name: "崇尚真知",
              score: "cszz",
            },
            {
              name: "理性思维",
              score: "lxsw",
            },
            {
              name: "勇于研究",
              score: "yyyj",
            },
          ],
        },
        {
          title: "审美情趣",
          items: [
            {
              name: "感悟鉴赏",
              score: "gwjs",
            },
            {
              name: "创意表达",
              score: "cybd",
            },
          ],
        },
        {
          title: "学会学习",
          items: [
            {
              name: "乐学善学",
              score: "lxsx",
            },
            {
              name: "勤于反思",
              score: "qyfs",
            },
            {
              name: "数字学习",
              score: "szxx",
            },
          ],
        },
        {
          title: "身心健康",
          items: [
            {
              name: "珍爱生命",
              score: "zasm",
            },
            {
              name: "健全人格",
              score: "jqrg",
            },
            {
              name: "适性发展",
              score: "sxfz",
            },
          ],
        },
        {
          title: "实践创新",
          items: [
            {
              name: "热爱劳动",
              score: "rald",
            },
            {
              name: "批判质疑",
              score: "ppzy",
            },
            {
              name: "问题解决",
              score: "wtjj",
            },
          ],
        },
      ],
      scoreDetail: {},
    };
  },
  created() {
    this.getChapterList();
    this.getDetail();
  },
  computed: {
    studentList() {
      return this.$store.state.studentList;
    },
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          let chapters = handleTree(res.data, "chapterId");

          chapters.forEach((item) => {
            if (item.children) {
              // 二级目录
              let secondArr = item.children;
              secondArr.forEach((s) => {
                if (s.children) {
                  // 三级目录为底层
                  let thirdArr = s.children;
                  let flag = thirdArr.every((t) => !t.complete);
                  if (flag) {
                    // 三级目录里全部未生成成绩
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  } else {
                    // 三级目录筛选
                    thirdArr.forEach((t) => {
                      if (!t.complete) {
                        thirdArr = thirdArr.filter(
                          (n) => n.chapterId != t.chapterId
                        );
                      }
                    });
                  }
                } else {
                  // 二级目录为底层
                  if (!s.complete) {
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  }
                }
              });
              // 一级目录的children赋值
              if (secondArr.length > 0) {
                item.children = secondArr;
              } else {
                delete item.children;
              }
            }
          });
          // 筛选掉一级目录中无children的，生成最终目录
          this.chapters = chapters.filter((item) => item.children);
        } else {
          console.log(res.msg);
        }
      });
    },
    getDetail() {
      let classChapterId = this.classChapterId;
      let userId = this.userId;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          userId,
          classChapterId,
        },
      });
      this.$loading.show();
      appraiseDetail({ classChapterId, userId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          if (res.data) this.scoreDetail = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.attainment_detail {
  //   height: 700px;
  background-image: url("../../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }
    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .btn {
      position: absolute;
      top: 62px;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../../assets/images/btn_bg.png");
      cursor: pointer;
      &.export_btn {
        right: 0;
      }
      &.student_btn {
        left: 0;
        ::v-deep .el-select {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }
      &.chapter_btn {
        left: 126px;
        ::v-deep .el-select,
        ::v-deep .el-cascader {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }

      ::v-deep .el-select,
      ::v-deep .el-cascader {
        .el-input__inner {
          padding-left: 20px;
          font-size: 14px;
          color: #fff;
          background-color: transparent;
          border: none;
        }
        .el-input__suffix {
          right: 10px;
          .el-select__caret {
            color: #fff;
          }
        }
      }
    }
  }
  .main {
    margin: 10px 0;
    padding-bottom: 10px;
    text-align: left;
    .box {
      display: inline-block;
      margin: 10px;
      width: 280px;
      color: #fff;
      text-align: center;
      vertical-align: top;
      .box_title {
        padding: 0 10px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        color: #1de0fe;
        background-color: rgba(49, 70, 125, 0.1);
        // border: solid 1px rgba(4, 20, 40, 0.1);
        box-shadow: #6be4f7 0px 0px 5px inset;
      }
      .content {
        padding: 20px;
        height: 220px;
        box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
        .one_row {
          //   padding: 6px 0;
          margin-bottom: 10px;
          color: #feffff;
          font-size: 16px;
          .score {
            display: inline-block;
            width: 36px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            text-align: center;
            border: solid 1px #feffff;
            color: #1de0fe;
          }
        }
      }
    }
  }
}
</style>